import angular from 'angular'
import template from './template.html'
import './style.scss'

angular.module('nominas.nomina')
  .component('nominaColaboradoresColaboradorConcepto', {
    template: template,
    controller: NominaColaboradoresColaboradorConceptoComponent,
    bindings: {
      nombre: '<',
      salarioDiario: '<',
      idTipoConcepto: '<',
      editarExento:'<',
      editable: '<',
      editarImporte: '<',
      editarDias: '<',
      editarHoras: '<',
      calculo: '<',
      data: '<',
      onChange: '&',
    },
  })

function NominaColaboradoresColaboradorConceptoComponent($parse) {
  let $ctrl = this

  $ctrl.$onInit = $onInit
  $ctrl.$onChanges = $onChanges
  $ctrl.calcular = calcular
  $ctrl.calcularGravado = calcularGravado

  function $onInit() {
    $ctrl.editando = true
    $ctrl.calculo = $parse($ctrl.calculo)
  }

  function $onChanges(changes) {
    if (changes.data) {
      validar()
    }
  }

  function redondear(value) {
    return (Number.isFinite(value) && value >= 0)
      ? parseFloat(value.toFixed(2))
      : null
  }

  function calcular() {
    let scope = {
      data: $ctrl.data,
      colaborador: {
        config: {
          salario_diario: $ctrl.salarioDiario,
        },
      },
    }

    $ctrl.calculo(scope)

    $ctrl.data = {
      importe: redondear(scope.data.importe) || 0,
      gravado: redondear(scope.data.gravado) || 0,
      exento: redondear(scope.data.exento) || 0,
      dias: redondear(scope.data.dias),
      horas: redondear(scope.data.horas),
    }

    validar()

    $ctrl.onChange({
      $event: {
        data: $ctrl.valido ? $ctrl.data : null,
      },
    })
  }

  function calcularGravado() {
    $ctrl.data.gravado = $ctrl.data.importe && Math.max(0, $ctrl.data.importe - $ctrl.data.exento)

    calcular()
  }

  function validar() {
    if (!$ctrl.data || !$ctrl.data.importe) {
      $ctrl.valido = false
    } else if ($ctrl.editarHoras) {
      $ctrl.valido = $ctrl.data.horas > 0
    } else if ($ctrl.editarDias) {
      $ctrl.valido = $ctrl.data.dias > 0
    } else {
      $ctrl.valido = true
    }
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/colaboradores/colaborador/concepto/component.js